import { useState, useMemo } from 'react';
import useLab2PageState from 'features/lab2/hooks/useLab2PageState';

const DEFAULT_AREA_RANGE = [15, 150];
const DEFAULT_TYPES = {
    apartment: true,
    multiFamily: true,
    officetel: true,
};

const buildPointParams = (areaRange, housingTypes) => {
    const range = areaRange ?? DEFAULT_AREA_RANGE;
    const types = housingTypes ?? DEFAULT_TYPES;
    return {
        minArea: range[0],
        maxArea: range[1],
        apartment: Boolean(types.apartment),
        multiFamily: Boolean(types.multiFamily),
        officetel: Boolean(types.officetel),
    };
};

export default function useHousingAppState() {
    const labState = useLab2PageState();
    const [currentAreaRange, setCurrentAreaRange] = useState(DEFAULT_AREA_RANGE);
    const [currentHousingTypes, setCurrentHousingTypes] = useState(DEFAULT_TYPES);

    const pointParams = useMemo(
        () => buildPointParams(currentAreaRange, currentHousingTypes),
        [currentAreaRange, currentHousingTypes]
    );
    const searchHousing = () => {};

    return {
        ...labState,
        currentAreaRange,
        setCurrentAreaRange,
        currentHousingTypes,
        setCurrentHousingTypes,
        pointParams,
        searchHousing,
    };
}
